import {
  Button,
  Container,
  FormControl,
  Grid,
  IconButton,
  InputAdornment,
  MenuItem,
  OutlinedInput,
  Pagination,
  Select,
  Stack,
  Typography,
} from "@mui/material";
import { Box } from "@mui/material";
import React from "react";
import { useEffect } from "react";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  agencyAllCategoryApi,
  agencyAllSubCategoryApi,
  AgencyListApi,
  expertAllCategoryApi,
  expertAllSubCategoryApi,
  ExpertSubCategoryApi,
  freelancerApi,
  serviceCategoryApi,
} from "../Component/API/Api";

import { Search } from "@mui/icons-material";
import AgencyCardItem from "../Component/Homepage Components/Agency/AgencyCardItem";
import AgencyCardItemNew from "../Component/Homepage Components/Agency/AgencyCardItemNew";

// const decodeLocalData = (name) => {
//   let result = atob(window.localStorage.getItem(name));
//   return JSON.parse(result);
// };
const AgencyList = () => {
  // let localData = decodeLocalData("gh_sl@g");
  const navigate = useNavigate();
  const [firstLoadIndegator, setFirstLoadIndegator] = useState(true);
  const [source, setSource] = useState("category");
  const [sourceValueId, setSourceValueId] = useState("");

  const [page, setPage] = useState(1);
  const [searchFieldText, setSearchFieldText] = useState("");
  const [agencyData, setAgencyData] = useState([]);
  const [category, setCategory] = useState("");
  const [subCategory, setSubCategory] = useState("");
  const [categoryListData, setCategoryListData] = useState([]);
  const [subCategoryListData, setSubCategoryListData] = useState([]);
  const [fetchedCategoryListData, setFetchedCategoryListData] = useState([]);
  const [fetchedSubCategoryListData, setfetchedSubCategoryListData] = useState(
    []
  );
  useEffect(() => {
    fetch(AgencyListApi)
      .then((res) => res.json())
      .then((result) => {
        setAgencyData(result?.data);
      })
      .catch((error) => console.log("agencyData Error => ", error));
  }, []);

  useEffect(() => {
    fetch(serviceCategoryApi)
      .then((res) => res.json())
      .then((result) => {
        setCategoryListData(result);
      })
      .catch((error) => console.log("ServiceApiError=> ", error));
  }, []);

  useEffect(() => {
    let found = categoryListData?.find(
      (element) => element.category_name === category
    );
    const formData = new FormData();
    formData.append("pref", found?.category_id ?? 1);
    formData.append("action", "fetch");

    fetch(ExpertSubCategoryApi, {
      method: "POST",
      body: formData,
    })
      .then((res) => res.json())
      .then((result) => {
        setSubCategoryListData(result);
      })
      .catch((error) => console.log("ServiceApiError=> ", error));

    fetch(agencyAllCategoryApi, {
      method: "POST",
      body: formData,
    })
      .then((res) => res.json())
      .then((result) => {
        setAgencyData(result);
      })
      .catch((error) => console.log("ServiceApiError=> ", error));
  }, [category]);

  useEffect(() => {
    let found = subCategoryListData?.find(
      (element) => element.sub_name === subCategory
    );

    const formData = new FormData();
    formData.append("pref", found?.sub_id ?? 1);
    formData.append("action", "fetch");

    fetch(expertAllSubCategoryApi, {
      method: "POST",
      body: formData,
    })
      .then((res) => res.json())
      .then((result) => {
        setAgencyData(result);
      })
      .catch((error) => console.log("ServiceApiError=> ", error));
  }, [subCategory]);

  useEffect(() => {
    const formData = new FormData();

    if (source === "category") {
      let found = categoryListData?.find(
        (element) => element.category_name === category
      );
      const formData = new FormData();
      formData.append("pref", found?.category_id ?? 1);
      formData.append("page", page);
      formData.append("action", "fetch");

      fetch(agencyAllCategoryApi, {
        method: "POST",
        body: formData,
      })
        .then((res) => res.json())
        .then((result) => {
          setAgencyData(result?.data);
        })
        .catch((error) => console.log("ServiceApiError=> ", error));
    } else {
      let found = subCategoryListData?.find(
        (element) => element.sub_name === sourceValueId
      );
      formData.append("pref", found?.sub_id ?? 1);
      formData.append("page", page);
      fetch(agencyAllSubCategoryApi, {
        method: "POST",
        body: formData,
      })
        .then((res) => res.json())
        .then((result) => {
          setAgencyData(result);
        })
        .catch((error) => console.log("ServiceApiError=> ", error));
    }
  }, [page]);

  const handlePageChange = (event, value) => {
    setFirstLoadIndegator(false);
    setPage(value);
  };
  const handleCategoryChange = (event) => {
    setCategory(event.target.value);
    setSource("category");
    setSourceValueId(event.target.value);
  };
  const handleSubCategoryChange = (event) => {
    setSubCategory(event.target.value);
    setSource("subCategory");
    setSourceValueId(event.target.value);
  };
  const handleSearch = () => {
    setFirstLoadIndegator(false);

    fetch(
      `//ap.songjukti.com/profile/login/api_freelancer/expert_all_search.php?s_query=${searchFieldText}`
    )
      .then((res) => res.json())
      .then((result) => {
        setAgencyData(result);
      })
      .catch((error) => console.log("agencyApiError=> ", error));
  };
  return (
    <Box>
      <Container sx={{ mt: "0px", width: "100%" }}>
        <Box mt={5}>{/* <ExpertListBanner /> */}</Box>
        <Stack
          direction={"row"}
          justifyContent="space-between"
          alignItems="center"
          mt={4}
        >
          <Stack
            direction={"row"}
            justifyContent="left"
            alignItems="center"
            spacing={1}
            sx={{ width: "35%" }}
          >
            <Typography variant="p" sx={{ fontWeight: 600 }}>
              Category:{" "}
            </Typography>
            <FormControl sx={{ width: "60%" }}>
              <Select
                value={category}
                onChange={handleCategoryChange}
                displayEmpty
                inputProps={{ "aria-label": "Without label" }}
                size="small"
              >
                <MenuItem value="">
                  <em>All</em>
                </MenuItem>
                {categoryListData.map((element) => (
                  <MenuItem value={element.category_name}>
                    {element.category_name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Stack>
          <Stack
            direction={"row"}
            justifyContent="left"
            alignItems="center"
            spacing={1}
            sx={{ width: "35%" }}
          >
            <Typography variant="p" sx={{ fontWeight: 600 }}>
              Sub Category:{" "}
            </Typography>
            <FormControl sx={{ width: "60%" }}>
              <Select
                value={subCategory}
                onChange={handleSubCategoryChange}
                displayEmpty
                inputProps={{ "aria-label": "Without label" }}
                size="small"
              >
                <MenuItem value="">
                  <em>All</em>
                </MenuItem>
                {subCategoryListData.map((element) => (
                  <MenuItem value={element.sub_name} key={element.sub_id}>
                    {element.sub_name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Stack>
          <OutlinedInput
            color="success"
            name="search_text"
            type="text"
            onChange={(e) => {
              setSearchFieldText(e.target.value);
            }}
            endAdornment={
              <InputAdornment position="end">
                <IconButton
                  aria-label="toggle password visibility"
                  size="small"
                  sx={{ marginTop: "5px", marginLeft: "10px" }}
                  onClick={() => {
                    handleSearch();
                  }}
                >
                  <Search />
                </IconButton>
              </InputAdornment>
            }
          />
        </Stack>
        {agencyData[0]?.agency_info?.c_refer ? (
          <Grid container spacing={2} mt={4} mb={4}>
            {agencyData?.map((element) => (
              <Grid
                item
                xs={6}
                sm={6}
                md={3}
                key={element.agency_info?.c_refer}
              >
                <AgencyCardItemNew
                  agencyData={element}
                  key={element.agency_info?.c_refer}
                />
              </Grid>
            ))}
          </Grid>
        ) : (
          <Box
            sx={{
              height: "57vh",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              flexDirection: "column",
            }}
          >
            {firstLoadIndegator ? (
              //   <img
              //     src={loading}
              //     alt="loading"
              //     style={{
              //       width: "120px",
              //       height: "120px",
              //     }}
              //   />
              <Typography
                variant="p"
                sx={{ fontSize: "25pt", fontWeight: 600 }}
              >
                Wait for sometime
              </Typography>
            ) : (
              <Typography
                variant="p"
                sx={{ fontSize: "25pt", fontWeight: 600 }}
              >
                No data found!
              </Typography>
            )}
          </Box>
        )}
        <Stack justifyContent={"space-between"} alignItems="center">
          <Pagination
            count={10}
            page={page}
            onChange={handlePageChange}
            variant="outlined"
            color="primary"
            sx={{ margin: "auto", marginBottom: "30px" }}
          />
        </Stack>
      </Container>
    </Box>
  );
};

export default AgencyList;
